module.exports = __webpack_public_path__ + "img/20200613_093024.7e9d2a24.jpg";